import { Select } from 'antd'
import React, { forwardRef } from 'react'

const normalizeText = (text = '') => text.toString().toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const DropdownWithAnt = forwardRef(({ className = '', status, ...props }, ref) => {
    return (
        <Select
            ref={ref}
            className={`w-full ${className} notranslate`}
            showSearch
            allowClear
            status={status}
            filterOption={(input, option) => {
                const optionText = normalizeText(option?.label ?? '');
                const searchText = normalizeText(input);
                return optionText.includes(searchText);
            }}
            {...props}
        />
    );
})

export default DropdownWithAnt
